
import { Component, Input, OnChanges, signal, SimpleChanges } from '@angular/core';
import { SvgIconsComponent } from "../../../commonComponent/svg-icons/svg-icons.component";

@Component({
    selector: 'app-short-detail-card',
    imports: [
    SvgIconsComponent
],
    templateUrl: './short-detail-card.component.html',
    styleUrl: './short-detail-card.component.css'
})
export class ShortDetailCardComponent implements OnChanges {
  @Input() list: any;

  searchData = signal<any>([]);

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['list']) {
      this.searchData.set(this.list);
    }
  }
}
